module.exports = __webpack_public_path__ + "img/stock1.d93c408f.png";